export default function(){
    jQuery('.announce').each(function(){
        jQuery(this).marquee({
            duration: 10000,
            pauseOnHover: true
        });
    });
}
